"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildField = exports.register = exports.propertySerializerName = void 0;
exports.propertySerializerName = "__serializer__";
function register(target, property, serializer) {
    if (!target[exports.propertySerializerName]) {
        Object.defineProperty(target, exports.propertySerializerName, {
            configurable: false,
            enumerable: false,
            writable: false,
            value: {},
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    target[exports.propertySerializerName][property.toString()] = serializer;
}
exports.register = register;
function buildField(serializer) {
    const Field = () => {
        const internalRegister = (target, property) => {
            register(target, property, serializer);
        };
        internalRegister.__serializer__ = serializer;
        return internalRegister;
    };
    return Field;
}
exports.buildField = buildField;
//# sourceMappingURL=register.js.map